class TokenService {
  constructor() {
    this.tokenKey = "hotel.one.bi.spa.token"
  }

  setToken(token) {
    localStorage.setItem(this.tokenKey, token)
  }

  getToken() {
    return localStorage.getItem(this.tokenKey)
  }

  removeToken() {
    localStorage.removeItem(this.tokenKey)
  }

  hasToken() {
    return !!this.getToken()
  }

  attachTokenToAxios(axiosInstance) {
    const token = this.getToken()
    if (token) {
      axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`
    }
  }
}

export default new TokenService()
